import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { DjangoService } from '@core/services/django.service';
import { EventTrackerService } from '@core/services/event-tracker.service';
import { ANALYTICS_EVENTS } from '@core/utils/AnalyticsEvents';
import { ModalData } from '@features/modal/interfaces/modal-data';
import { ModalService } from '@features/modal/services/modal.service';
import { ActiveCampaignLeadMagnet } from '@generated/graphql';
import { SaveButtonComponent } from '../../../../shared/save-button/save-button.component';

@Component({
    selector: 'app-lead-magnet-active-campaign-modal',
    templateUrl: './lead-magnet-active-campaign-modal.component.html',
    styleUrls: ['./lead-magnet-active-campaign-modal.component.css'],
    imports: [ReactiveFormsModule, SaveButtonComponent],
})
export class LeadMagnetActiveCampaignModalComponent
    implements OnInit, ModalData<{ leadMagnet: ActiveCampaignLeadMagnet }>
{
    showLoader = false;
    success = false;
    error = false;

    readonly modalStyle = ['bg-blue text-white'];
    readonly navigationStyle = ['bg-blue text-white'];

    modalData: { leadMagnet: ActiveCampaignLeadMagnet; isExitIntent?: boolean };
    leadMagnetForm: UntypedFormGroup;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private cd: ChangeDetectorRef,
        private modalService: ModalService,
        private djangoService: DjangoService,
        private eventTrackerService: EventTrackerService
    ) {}

    ngOnInit(): void {
        this.leadMagnetForm = this.formBuilder.group({
            firstName: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
        });
    }

    onSubmit() {
        if (this.leadMagnetForm.valid) {
            this.showLoader = true;
            const values = this.leadMagnetForm.value;
            const data = {
                email: values.email,
                first_name: values.firstName,
                lead_magnet: this.modalData.leadMagnet.sys.id,
            };

            this.djangoService.leadMagnet(data).subscribe({
                next: () => {
                    this.success = true;
                    this.showLoader = false;
                    this.cd.detectChanges();
                    const eventTitle = this.modalData.isExitIntent
                        ? ANALYTICS_EVENTS.LEAD_MAGNET_EXIT_INTENT_COMPLETED
                        : ANALYTICS_EVENTS.LEAD_MAGNET_COMPLETED;
                    this.eventTrackerService.trackEvent(
                        eventTitle,
                        {
                            leadMagnet: this.modalData.leadMagnet.title,
                            tag: this.modalData.leadMagnet.activeCampaignTag,
                        },
                        data.email
                    );
                    setTimeout(() => this.modalService.hide(), 2000);
                },
                error: error => {
                    this.success = false;
                    this.showLoader = false;
                    this.error = true;
                    this.cd.detectChanges();
                },
            });
        }
    }
}
